export default __webpack_public_path__ + "static/media/KumarOne-Regular.cc90ef47.ttf";